module.exports = __webpack_public_path__ + "img/illu-onboarding.1070e30c.png";